import SearchNotFoundLayoutProvider from './hooks/useSearchNotFoundLayout';

import { SearchNotFoundLayoutProps } from './@types/SearchNotFoundLayoutProps';
import SearchNotFoundLayoutContainer from './handles/SearchNotFoundLayoutContainer';

const SearchNotFoundLayout = (props: SearchNotFoundLayoutProps) => (
	<SearchNotFoundLayoutProvider {...props}>
		<SearchNotFoundLayoutContainer>{props.children}</SearchNotFoundLayoutContainer>
	</SearchNotFoundLayoutProvider>
);

export default SearchNotFoundLayout;
